<template>
  <div class="husmind">
    <canvas id="renderCanvas"></canvas>
    <b-modal
      :title="ModalHtmlTitle"
      size="xl"
      class="modal-primary"
      scrollable
      v-model="ModalHtmlDisplay"
      ok-only
      ok-variant="secondary"
      ok-title="Close / Cerrar"
    >
      <contentHtml :ModalHtmlContent="ModalHtmlContent"></contentHtml>
    </b-modal>
    <div id="controls">
      <div>
        <span class="spc"></span>
        <span v-hammer:press="avanzar" v-hammer:pressup="detener" class="btn_arrow">
          <div class="arrow_up">
            <div class="arrow"></div>
          </div>
        </span>
        <span class="spc"></span>
        <span v-hammer:press="izquierda" v-hammer:pressup="detener" class="btn_arrow">
          <div class="arrow_left">
            <div class="arrow"></div>
          </div>
        </span>
        <span v-hammer:press="retroceder" v-hammer:pressup="detener" class="btn_arrow">
          <div class="arrow_down">
            <div class="arrow"></div>
          </div>
        </span>
        <span v-hammer:press="derecha" v-hammer:pressup="detener" class="btn_arrow">
          <div class="arrow_right">
            <div class="arrow"></div>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import * as BABYLON from 'babylonjs'

// debug
// import 'babylonjs-inspector'
import Environment from '@/core/Environment.js'
import { Keys } from '@/core/Keys.js'
import Avatar from '@/core/Avatar.js'
// import { loadInstances } from '@/core/instances.js'
import { pantallas } from '@/core/utils.js'
import { initGeneralMaterials } from '@/core/materials.js'
// import jsxc from 'jsxc'
import io from 'io'
import { EventBus } from '@/js/EventBus.js'
// import { VueHammer } from 'vue2-hammer'
import ENV from 'ENV'

import { mapMutations, mapState } from 'vuex'
import contentHtml from '@/views/Content/HtmlContent'

export default {
  name: 'world',
  components: {
    contentHtml
  },
  data () {
    return {
      objeto: {
        parametro1: '',
        parametro2: ''
      },
      keys: null,
      mensaje: 'test de mensaje',
      ModalHtmlDisplay: false,
      ModalHtmlContent: '',
      ModalHtmlTitle: ''
    }
  },
  props: {
    list: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  created () {
    // let testScript = document.createElement('script')
    // testScript.setAttribute('src', 'static/test.js')
    // document.head.appendChild(testScript)
  },
  computed: {
    // ...mapState(['environment'])
    ...mapState(['hScene'])
  },
  methods: {
    ...mapMutations(['newHScene', 'setHScene']),
    iniciar () {

    },
    avanzar (e) {
      this.keys.up = true
    },
    retroceder (e) {
      this.keys.down = true
    },
    derecha (e) {
      this.keys.right = true
    },
    izquierda (e) {
      this.keys.left = true
    },
    detener (e) {
      this.keys.up = false
      this.keys.down = false
      this.keys.right = false
      this.keys.left = false
    }
  },
  mounted: function () {
    let dimension = this.$route.params.dimension
    console.log(dimension)

    EventBus.$on('registerHObjectEvent', (obj) => {
      let hApp = window.hScene.activators[obj.indexActivator].hApp
      let hObject = hApp.content.hObjects[obj.instruction.target]

      hObject.allowRegistration = true
      if (obj.instruction.value) {
        window.hScene.registerHObject(hObject)
      } else {
        window.hScene.unRegisterHObject(hObject)
      }
    })

    EventBus.$on('authenticationEvent', (obj) => {
      let sesion = JSON.parse(sessionStorage.getItem('datos_usuario_autenticado'))
      // Verificación de imagen de avatar en el sistema
      // console.log('sessionStorage' + sesion)
      if (sesion !== null) {
        environment.localAvatar.setImageAvatar(sesion.imagen_genero)
        environment.localAvatar.email = sesion.correo_electronico
        environment.localAvatar.name = `${sesion.primer_nombre} ${sesion.segundo_nombre}`
      } else {
        environment.localAvatar.setImageAvatar('profiles/anonymous.png')
      }
    })

    EventBus.$on('selectEvent', (obj) => {
      let h = obj.name.split('.')

      let hApp = window.hScene.hApps[h[0]]
      let hObject = hApp.getHObjectByName(h[1])
      let widget = hObject.getWidgetByName(obj.name)
      if (widget !== undefined) {
        console.log('Widget:')
        console.log(widget)
        if (widget.html.trim() !== '' || widget.zoom) {
          this.ModalHtmlTitle = widget.title
          this.ModalHtmlContent = widget
          this.ModalHtmlDisplay = true
        }
        else if (widget.url !== '') {
          var win = window.open(widget.url, '_blank')
          if (win) {
            win.focus()
          } else {
            alert('Please allow popups for this website')
          }
        }
      }

      console.log(hObject.getMeshRoot().name)
      environment.localAvatar.target.x = hObject.getMeshRoot().position.x
      environment.localAvatar.target.z = hObject.getMeshRoot().position.z

    })

    // Initialise socket connection
    try {
      var socket = io(ENV.server_multipresence)
    } catch (err) { }

    // var salaChat = ''

    this.keys = new Keys()
    let environment = new Environment()
    window.environment = environment


    environment.go('home')

    window.hScene
    // this.newHScene()
    this.setHScene (window.hScene)

    initGeneralMaterials()
    setSocketEventHandlers()
    // debug
    // window.scene.debugLayer.show() // Este es el que se usa

    // scene.debugLayer.show({
    //   // overlay: false,
    //   // globalRoot: document.getElementById('#mydiv')
    // })

    var testr = BABYLON.Mesh.CreateBox('box', 1, window.scene, true, BABYLON.Mesh.DOUBLESIDE)
    testr.rotation.x = -90 * Math.PI / 4
    testr.scaling.y = 0.1
    testr.position = new BABYLON.Vector3(20, 100, 500)

    var _this = this
    // run the render loop
    environment.engine.runRenderLoop(function () {
      var forward = new BABYLON.Vector3(parseFloat(Math.sin(parseFloat(testr.rotation.y))) / 40, -1, parseFloat(Math.cos(parseFloat(testr.rotation.y))) / 40)
      testr.moveWithCollisions(forward)

      environment.localAvatar.lookAt()

      // console.log(window.hScene.hObjectsRegisterQueue)
      if (Math.floor((Math.random() * 50) + 1) === 1) {
        // console.log('Revision periódica de cola ****** **** *** ** * ' + hScene.hObjectsRegisterQueue.length)
        for (let i = 0; i < window.hScene.hObjectsRegisterQueue.length; i++) {
          // console.log('Elemento con estado registered:')
          // console.log(hScene.hObjectsRegisterQueue[i].registered)
          if (window.hScene.hObjectsRegisterQueue[i].registered === false) {
            window.hScene.hObjectsRegisterQueue[i].register()
          }
          if (window.hScene.hObjectsRegisterQueue[i].registered) { // Si ya está registrado se debe sacar de la cola
            // console.log('Elemento registrado exitosamente!' + i)
            window.hScene.hObjectsRegisterQueue.splice(i, 1)
          }
        }
      }

      // update()
      // console.log(localAvatar)
      if (typeof environment.localAvatar !== 'undefined' && environment.localAvatar.applyGravity) {
        var verctorCaida = new BABYLON.Vector3(0, -0.5, 0)
        // verctorCaida = new BABYLON.Vector3(0, 0, 0)
        environment.localAvatar.getRepresentacion().moveWithCollisions(verctorCaida)
        if (environment.localAvatar.position.y < -10) {
          environment.localAvatar.setY(20)
        }

        // Activators
        window.hScene.activators.forEach(function (activator, index, array) {
          if (environment.localAvatar.getRepresentacion().intersectsMesh(activator.hObject.getMesh(), false)) {
            activator.hObject.run(index)
          }
        })

        // for (var nbanda = 1; nbanda < 13; nbanda++) {
        //   if (localAvatar.getBase().intersectsMesh(scene.getMeshByName('banda' + nbanda), false)) {
        //     localAvatar.setZ(localAvatar.position.z + 0.6)
        //     socket.emit('move player', {x: localAvatar.position.x, y: localAvatar.position.y, z: localAvatar.position.z, rotY: localAvatar.rotation.y})
        //     // console.log('si intersecta')
        //   }
        //   nbanda++
        //   if (localAvatar.getBase().intersectsMesh(scene.getMeshByName('banda' + nbanda), false)) {
        //     localAvatar.setZ(localAvatar.position.z - 0.6)
        //     socket.emit('move player', {x: localAvatar.position.x, y: localAvatar.position.y, z: localAvatar.position.z, rotY: localAvatar.rotation.y})
        //   }
        // }
        // for (nbanda = 13; nbanda < 21; nbanda++) {
        //   if (localAvatar.getBase().intersectsMesh(scene.getMeshByName('banda' + nbanda), false)) {
        //     localAvatar.setX(localAvatar.position.x - 0.6)
        //     socket.emit('move player', {x: localAvatar.position.x, y: localAvatar.position.y, z: localAvatar.position.z, rotY: localAvatar.rotation.y})
        //   }
        //   nbanda++
        //   if (localAvatar.getBase().intersectsMesh(scene.getMeshByName('banda' + nbanda), false)) {
        //     localAvatar.setX(localAvatar.position.x + 0.6)
        //     socket.emit('move player', {x: localAvatar.position.x, y: localAvatar.position.y, z: localAvatar.position.z, rotY: localAvatar.rotation.y})
        //   }
        // }

        // var sesion = sessionStorage.getItem('datos_usuario_autenticado')
        // if (sesion !== null && window.scene.getMeshByName('base-multi-expo') !== undefined) {
        //   if (localAvatar.getBase().intersectsMesh(window.scene.getMeshByName('base-multi-expo'), false)) {
        //     if (salaChat !== 'multi-expo') {
        //       salaChat = 'multi-expo'
        //       // console.log('base-multi-expo')
        //       // jsxc.muc.joinChat('multi-expo', JSON.parse(sesion).nombre_completo)
        //     }
        //   }
        // }
        // debugger
        // if (sesion !== null && window.scene.getMeshByName('base-standspe') !== undefined) {
        //   if (localAvatar.getBase().intersectsMesh(window.scene.getMeshByName('base-standspe'), false)) {
        //     if (salaChat !== 'spe') {
        //       salaChat = 'spe'
        //       // console.log('spe')
        //       // jsxc.muc.joinChat('spe', JSON.parse(sesion).nombre_completo)
        //     }
        //   }
        // }

        // DETECTOR DE REPRODUCCIÓN DE VIDEOS
        for (var i = 0; i < pantallas.length; i++) {
          if (enRadio(pantallas[i].getRadio(), environment.localAvatar.position.x, environment.localAvatar.position.z, -149.58, -741.88) && !pantallas[i].getIniciado()) {
            pantallas[i].cargarVideo()
            pantallas[i].setIniciado(true)
            // var room = `welcome@conference.${ENV.server_name_xmpp}`

            // if (salaChat !== 'welcome' || false) {
            //   salaChat = 'welcome'
            //   var sesion = sessionStorage.getItem('datos_usuario_autenticado')
            //   // jsxc.muc.joinChat(`welcome@conference.${ENV.server_name_xmpp}`, JSON.parse(sesion).nombre_completo)
            //   jsxc.gui.dialog.open('Ingresando a área de chat...') // Si aparece el cuadro de dialogo primero si se maximiza la ventana de chat

            //   jsxc.muc.join(`${salaChat}@conference.${ENV.server_name_xmpp}`, JSON.parse(sesion).nombre_completo, null, null, null, null)
            // }

            // } else if (!enRadio(pantallas[i].getRadio(), localAvatar.position.x, localAvatar.position.z, pantallas[i].getX() - 175, pantallas[i].getZ() - 775) && pantallas[i].getIniciado()) {
          } else if (!enRadio(pantallas[i].getRadio(), environment.localAvatar.position.x, environment.localAvatar.position.z, -149.58, -741.88) && pantallas[i].getIniciado()) {
            pantallas[i].pausarVideo()
          } else if (enRadio(pantallas[i].getRadio(), environment.localAvatar.position.x, environment.localAvatar.position.z, -149.58, -741.88) && pantallas[i].getIniciado()) {
            pantallas[i].reproducirVideo()
          }
        }

        // console.log('camara:::' + camera)
        environment.camera.lockedTarget = environment.localAvatar.getRepresentacion()
        environment.camera.lockedTarget = environment.localAvatar.getRepresentacion()

        if (environment.localAvatar.update(_this.keys)) { // Si oprimio tecla se actualiza la posición
          window.scene.activeCamera = environment.camera
          socket.emit('move player', { x: environment.localAvatar.position.x, y: environment.localAvatar.position.y, z: environment.localAvatar.position.z, rotY: environment.localAvatar.rotation.y })
          if (Math.floor((Math.random() * 100) + 1) === 1) {
            socket.emit('rename', { name: environment.localAvatar.getRepresentacion().name, image: environment.localAvatar.avatar, email: environment.localAvatar.email })
            // console.log('nombre de imagen de avatar emitida: ' + localAvatar.avatar)
          }
        }
        // scene.getMeshesByTags('box', function (ct) { ct.rotation.x += 0.01;});
      }

      if (window.scene.getMaterialByName('materialBanda') != null) {
        window.scene.getMaterialByName('materialBanda').emissiveTexture.uOffset += 0.06
        if (window.scene.getMaterialByName('materialBanda').emissiveTexture.uOffset === 1) {
          window.scene.getMaterialByName('materialBanda').emissiveTexture.uOffset = 0
        }
      }

      window.scene.render()
    })
    // the canvas/window resize event handler
    window.addEventListener('resize', function () {
      environment.engine.resize()
    })

    function enRadio (radio, x1, y1, x2, y2) {

      var distancia = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2))

      if (Math.abs(distancia) < radio) {
        return true
      }
      return false
    }

    function onKeydown (e) {
      // if (true) {
      _this.keys.onKeyDown(e)
      // console.log('Avatar: ' + localAvatar.position.x + ', ' + localAvatar.position.z)
      // }
    }
    function onKeyup (e) {
      // if (true) {
      _this.keys.onKeyUp(e)
      // }
    }

    function setEventHandlers () {
      // Mouse
      // window.addEventListener('mousedown', selectCameraFP, false)
      // Keyboard
      // Select firts person camera

      window.addEventListener('keydown', onKeydown, false)
      window.addEventListener('keyup', onKeyup, true)
    }

    function setSocketEventHandlers () {
      // Socket connection successful
      socket.on('connect', onSocketConnected)

      // Socket disconnection
      socket.on('disconnect', onSocketDisconnect)

      // New avatar message received
      socket.on('new player', onNewAvatar)

      // Player move message received
      socket.on('move player', onMoveAvatar)

      // Player removed message received
      socket.on('remove player', onRemoveAvatar)

      // Player renamed message received
      socket.on('rename', onRemame)
    }

    // Socket connected
    function onSocketConnected () {
      console.log('Connected to socket server')

      // Send local player data to the game server
      socket.emit('new player', { x: environment.localAvatar.position.x, y: environment.localAvatar.position.y, z: environment.localAvatar.position.z })
    }

    // Socket disconnected
    function onSocketDisconnect () {
      console.log('Disconnected from socket server')
    }

    // New Avatar
    function onNewAvatar (data) {
      console.log('New avatar connected: ' + data.id)

      // Initialise the new player
      var newAvatar = new Avatar(data.x, data.y, data.z, window.scene)
      newAvatar.id = data.id

      // Add new Avatar to the remote avatars array
      environment.remoteAvatars.push(newAvatar)

      // Add name to mesh.name
      if (data.name !== 'Anonymous') {
        newAvatar.getRepresentacion().name = data.name
        newAvatar.setImageAvatar(data.image)

        // Add label to player
        newAvatar.label = label(newAvatar.getRepresentacion())
      }
    }

    // Move player
    function onMoveAvatar (data) {
      var moveAvatar = avatarById(data.id)

      // Player not found
      if (!moveAvatar) {
        // console.log('Player not found: ' + data.id)
        return
      }

      // Update player position
      moveAvatar.setX(data.x)
      moveAvatar.setY(data.y)
      moveAvatar.setZ(data.z)
      moveAvatar.setRotY(data.rotY)

      // console.log(data.x+', '+data.y+', '+data.z);
      // console.log(moveAvatar.getX()+', '+moveAvatar.getY()+', '+moveAvatar.getZ());
    }

    // Remove player
    function onRemoveAvatar (data) {
      var removeAvatar = avatarById(data.id)

      // Player not found
      if (!removeAvatar) {
        // console.log('Player not found: '+data.id);
        return
      }

      // Remove player from array
      if (removeAvatar.label !== undefined) {
        removeAvatar.label.dispose()
      }
      removeAvatar.getRepresentacion().dispose()
      environment.remoteAvatars.splice(environment.remoteAvatars.indexOf(removeAvatar), 1)
    }

    // Rename player
    function onRemame (data) {
      var renameAvatar = avatarById(data.id)

      // Player not found
      if (!renameAvatar) {
        // console.log('Player not found: '+data.id);
        return
      }

      renameAvatar.getRepresentacion().name = data.name
      renameAvatar.getRepresentacion().image = data.image
      renameAvatar.setImageAvatar(data.image)
      renameAvatar.email = data.email
      console.log('Email recibido: ' + data.email)

      // Add label to player
      renameAvatar.label = label(renameAvatar.getRepresentacion())

      renameAvatar.getRepresentacion().actionManager = new BABYLON.ActionManager(window.scene)
      renameAvatar.getRepresentacion().actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, function () {
        console.log('Presentando el email...')
        console.log(data.email)
      }))
    }

    // Find player by ID
    function avatarById (id) {
      var i
      for (i = 0; i < environment.remoteAvatars.length; i++) {
        if (environment.remoteAvatars[i].id === id) {
          return environment.remoteAvatars[i]
        }
      }

      return false
    }

    function label (mesh) {
      //   return new BABYLON.Group2D({
      //     parent: $scope.screenCanvas, id: 'GroupTag #', width: 80, height: 40, trackNode:mesh, origin: BABYLON.Vector2.Zero(),
      //     children: [new BABYLON.Rectangle2D({ id: 'firstRect', width: 80, height: 26, x: -40, y: 0, origin: BABYLON.Vector2.Zero(),
      //     border: 'none', fill: 'none',
      //     children: [new BABYLON.Text2D(mesh.name, { marginAlignment: 'h: center, v:center', fontName: 'bold 12px Arial' })]})
      //   ]
      // })
    }

    // var myBlock = document.getElementById('controls')
    // // var statusBar = document.getElementById('status')

    // // create a simple instance on our object
    // var mc = new VueHammer(myBlock)

    // // add a 'PAN' recognizer to it (all directions)
    // mc.add(new VueHammer.Pan({ direction: VueHammer.DIRECTION_ALL, threshold: 0 }))

    // // tie in the handler that will be called
    // mc.on('pan', handleDrag)
    // console.log('********* KKKKKKKKKKKKKKKKKK')
    // console.log(mc)
    // // poor choice here, but to keep it simple
    // // setting up a few vars to keep track of things.
    // // at issue is these values need to be encapsulated
    // // in some scope other than global.
    // var lastPosX = 0
    // var lastPosY = 0
    // var isDragging = false
    // function handleDrag (ev) {
    //   onsole.log('********* KKKKKKKKKKKKKKKKKK YYYYYYY')
    //   console.log(ev.type)
    //   // for convience, let's get a reference to our object
    //   var elem = ev.target

    //   // DRAG STARTED
    //   // here, let's snag the current position
    //   // and keep track of the fact that we're dragging
    //   if (!isDragging) {
    //     isDragging = true
    //     lastPosX = elem.offsetLeft
    //     lastPosY = elem.offsetTop
    //     setStatus('You, sir, are dragging me...')

    //     setBlockText('WOAH')
    //   }

    //   // we simply need to determine where the x,y of this
    //   // object is relative to where it's 'last' known position is
    //   // NOTE:
    //   //    deltaX and deltaY are cumulative
    //   // Thus we need to always calculate 'real x and y' relative
    //   // to the 'lastPosX/Y'
    //   var posX = ev.deltaX + lastPosX
    //   var posY = ev.deltaY + lastPosY

    //   // move our element to that position
    //   elem.style.left = posX + 'px'
    //   elem.style.top = posY + 'px'

    //   // DRAG ENDED
    //   // this is where we simply forget we are dragging
    //   if (ev.isFinal) {
    //     isDragging = false
    //     setStatus('Much better. Its nice here.')
    //     setBlockText('Thanks')
    //   }
    // }

    // function setStatus (msg) {
    //   // statusBar.textContent = msg;
    //   console.log(msg)
    // }
    // function setBlockText (msg) {
    //   // myBlock.textContent = msg;
    //   console.log(msg)
    // }

    setEventHandlers()
  }
}
</script>

<style lang='css'>
#renderCanvas {
  position: fixed;
  top: 55px;

  width: 100%;
  height: calc(100% - 105px);
  /*touch-action: none;*/
}

#controls {
  position: fixed;
  z-index: 0;
  bottom: 78px;
  margin-left: 32px;
  width: 186px;
  height: 120px;
  justify-content: center;
}

#controls img {
  width: 60px;
  height: 60px;
  border-radius: 20px;
}

.btn_arrow {
  float: left;
  margin-bottom: 0.2vh;

  width: 60px;
  height: 60px;
  border-radius: 20px;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 10px;
}

.spc {
  float: left;
  margin-bottom: 0.2vh;

  width: 60px;
  height: 60px;
  border-radius: 5px;
}

.arrow {
  height: 30px;
  width: 30px;
  border: 1px solid rgb(255, 255, 255);
  border-width: 3px 3px 0 0;
}

.arrow_up {
  transform: rotate(-45deg);
  padding: 15px 5px;
}

.arrow_left {
  transform: rotate(-135deg);
  padding: 5px;
}
.arrow_right {
  transform: rotate(45deg);
  padding: 5px;
}
.arrow_down {
  transform: rotate(135deg);
  padding: 0px 0px 0px 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/World.vue